// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "社会工作概论",
      "tec": "赵勤",
      "week": "6-14,16-18周",
      "add": "教学楼D座414经管"
    },
    {
      "sub": "心理学概论",
      "tec": "陈阳",
      "week": "6-14,16-18周",
      "add": "教学楼D座321文法"
    },
    {
      "sub": "军事理论",
      "tec": "王淑慧",
      "week": "6-14周",
      "add": "教学楼D座321文法"
    },
    {
      "sub": "形势与政策",
      "tec": "祝嘉悦",
      "week": "6-9周",
      "add": "教学楼C座113教务"
    },
    0
  ],
  "2": [
    0,
    [
      {
        "sub": "大学英语（一）",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "26经管2-1",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26经管2-2",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "26经管1-1",
        "tec": "王国志",
        "week": "6-17周",
        "add": "实训楼E座414管理"
      }
    ],
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[05-06节]）"
    },
    0,
    0
  ],
  "3": [
    [
      {
        "sub": "人工智能与计算思维",
        "tec": "刘鑫",
        "week": "6,8,10,12,14,16周",
        "add": "实训楼C座318"
      },
      {
        "sub": "人工智能与计算思维",
        "tec": "刘鑫",
        "week": "7,9,11,13,17周",
        "add": "教学楼D座324经管"
      }
    ],
    {
      "sub": "心理学概论",
      "tec": "陈阳",
      "week": "6-14,16-18周",
      "add": "教学楼D座413文法"
    },
    0,
    0,
    {
      "sub": "健康教育",
      "tec": "姜浩安",
      "week": "6-17周",
      "add": "教学楼C座112教务"
    }
  ],
  "4": [
    {
      "sub": "社会工作概论",
      "tec": "赵勤",
      "week": "6-14,16-18周",
      "add": "教学楼D座222经管"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "王国志",
        "week": "6-17周",
        "add": "教学楼D座320经管"
      },
      {
        "sub": "26经管1-2",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "教学楼D座226经管"
      },
      {
        "sub": "26经管2-1",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "教学楼A座122信息"
      },
      {
        "sub": "26经管2-2",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "教学楼D座326文法"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "李化",
      "week": "6-10周",
      "add": "教学楼D座214经管"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "人工智能与计算思维",
      "tec": "刘鑫",
      "week": "7,9,11,13,17周",
      "add": "教学楼D座324经管"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
